// @ts-nocheck
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {UserActionsCell} from './UserActionsCell'
import {UserSelectionCell} from './UserSelectionCell'
import {UserCustomHeader} from './UserCustomHeader'
import {UserSelectionHeader} from './UserSelectionHeader'
import {User} from '../../core/_models'

const usersColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => <UserSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({...props}) => <UserSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Code' className='min-w-125px' />,
    id: 'code',
    accessor: 'code',
    Cell: ({ ...props }) => props.data[props.row.index].code,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Discount' className='min-w-125px' />,
    id: 'discount',
    accessor: 'discount',
    Cell: ({ ...props }) => props.data[props.row.index].discount,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Discount Type' className='min-w-125px' />,
    id: 'discount_type',
    accessor: 'discount_type',
    Cell: ({ ...props }) => props.data[props.row.index].discount_type,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Max Discount' className='min-w-125px' />,
    id: 'max_discount',
    accessor: 'max_discount',
    Cell: ({ ...props }) => props.data[props.row.index].max_discount,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Min Buy' className='min-w-125px' />,
    id: 'min_buy',
    accessor: 'min_buy',
    Cell: ({ ...props }) => props.data[props.row.index].min_buy,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Coupon Title' className='min-w-125px' />,
    id: 'coupon_title',
    accessor: 'coupon_title',
    Cell: ({ ...props }) => props.data[props.row.index].coupon_title,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Description' className='min-w-125px' />,
    id: 'coupon_description',
    accessor: 'coupon_description',
    Cell: ({ ...props }) => props.data[props.row.index].coupon_description,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Start Date' className='min-w-125px' />,
    id: 'start_date',
    accessor: 'start_date',
    Cell: ({ ...props }) => props.data[props.row.index].start_date,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='End Date' className='min-w-125px' />,
    id: 'end_date',
    accessor: 'end_date',
    Cell: ({ ...props }) => props.data[props.row.index].end_date,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='One-Time Use' className='min-w-125px' />,
    id: 'is_onetime',
    accessor: 'is_onetime',
    Cell: ({ ...props }) => (props.data[props.row.index].is_onetime === '1' ? 'Yes' : 'No'),
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Coupon Image' className='min-w-125px' />,
    id: 'coupon_image',
    accessor: 'coupon_image',
    Cell: ({ ...props }) => (
      props.data[props.row.index].coupon_image ? (
        <img 
          src={props.data[props.row.index].coupon_image} 
          alt="Coupon" 
          style={{ width: '50px', height: '50px', objectFit: 'cover' }} 
        />
      ) : (
        'No Image'
      )
    ),
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Coupon Service' className='min-w-125px' />,
    id: 'coupon_service',
    accessor: 'coupon_service',
    Cell: ({ ...props }) => props.data[props.row.index].coupon_service || 'N/A',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <UserActionsCell id={props.data[props.row.index].id} />,
  },
]

export {usersColumns}
